<template>  
   
    <div>  
        <label>{{label}}
        <input 
        v-model="value2"
        type="checkbox"
        :disabled="disabled"
        />
        </label>
        <div><span v-for="item in errorMsgs">{{item}}</span></div>
    </div>
    
</template>

<script>
    import InputBase from './InputBase';
    export default {
        mixins: [InputBase],
        props: ['appendIcon', 'appendIconCb','appendOuterIcon', 'appendOuterIconCb','prependIcon', 'disabled'],
        data(){
            return{
                value2: null
            };
        },
         created: () => {
            this.value2 = this.value;
        },
        watch:{
            value2(v){
                this.emit(v);
                this.touch();
            },
            value: {
                handler(va, old) {
                    if(va === this.value2) return;
                    this.value2 = va;
                },
                immediate: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/public_app/elements/Switch.vue